import React from 'react';
import { Box, Typography, Alert } from '@mui/material';

const Profile = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Mon Profil
      </Typography>
      <Alert severity="info">
        Cette fonctionnalité sera implémentée prochainement.
      </Alert>
    </Box>
  );
};

export default Profile;